module.exports = __webpack_public_path__ + "static/media/face.c413fb87.png";